import { mapGetters } from "vuex";
import { sizeHelper, stringHelper } from "@/components/mixins/"

export default {
  name: "MleInvoiceDetailsGrid",
  mixins: [ sizeHelper, stringHelper ],
  props: {
    details: {
      type: Object,
      default: null
    },
    relatedOrders: {
      type: Array,
      default: null
    }
  },
  computed: {
    ...mapGetters(["getContentItem", "user", "activeAccountId"]),

    lineItems() {
      const list = this.details.LineItems || [];

      return list.map((item, i) => {
        return {
          ...item,
          rowSpan:
            i === 0 || item.SalesOrderNumber !== list[i - 1].SalesOrderNumber
              ? list.filter(x => x.SalesOrderNumber === item.SalesOrderNumber)
                .length
              : null
        };
      });
    },
  },
  data: () => ({
    selectedLineItems: [],
    isLoadingClaimData: false
  }),
};